import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { customStyle } from 'helper';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';

function OwnerComponent({
  value,
  onChange,
  ownerList,
  getLandOwnerList,
  formData,
}) {
  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    setItem({
      item: value || [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const updateProps = (newItem) => {
    onChange(_.get(newItem, 'item'));
  };

  const handleAddItem = () => {
    setItem({
      item: (items.item || []).concat([
        {
          id: (_.get(items, `item.${items.item.length - 1}.id`) || 0) + 1,
          rptax_co_owners: '',
        },
      ]),
    });
  };

  const handleRemoveItem = (item) => () => {
    const newItem = {
      item: (items.item || []).filter((x) => x.id !== item.id),
    };
    setItem(newItem);
    updateProps(newItem);
  };

  useEffect(() => {
    getLandOwnerList();
  }, []);

  const createDropDown = (list) => {
    const newList = [];
    const filterList = _.filter(
      list,
      (selected) => selected.id !== formData.rptax_owner_id
    );
    filterList.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const handleOnChangeSelect = (item, key) => (e) => {
    const newItem = {
      item: (items.item || []).map((x) =>
        x.id === item.id ? { ...x, [key]: e.value } : x
      ),
    };
    setItem(newItem);
    updateProps(newItem);
  };

  return (
    <>
      <div className="col-12 form-group">
        <table
          width="100%"
          className="strip-table table table-sm table-bordered"
        >
          <thead className="table-header">
            <tr>
              <td width="150">
                <span className="font-weight-bold">Co-Owner</span>
              </td>
              <td width="50">
                <span className="font-weight-bold">Action</span>
              </td>
            </tr>
          </thead>
          <tbody className="p-3">
            {(items.item || []).map((item, i) => (
              <tr key={+item.id}>
                <td width="150">
                  <Select
                    options={createDropDown(ownerList).filter(
                      (data) =>
                        items.item
                          .map((e) => e.rptax_co_owners)
                          .indexOf(_.get(data, 'value')) === -1
                    )}
                    styles={customStyle}
                    // isClearable
                    placeholder="Select Co-Owner"
                    value={
                      createDropDown(ownerList).filter(
                        (data) =>
                          +_.get(item, 'rptax_co_owners') ===
                          +_.get(data, 'value')
                      ) || ''
                    }
                    onChange={handleOnChangeSelect(item, 'rptax_co_owners')}
                  />
                </td>
                {i !== 0 && (
                  <td width="50">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemoveItem(item)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mt-2">
          <button
            type="button"
            onClick={handleAddItem}
            className="btn button-add-another"
          >
            <i className="fas fa-plus" /> &nbsp; Add another
          </button>
        </div>
      </div>
    </>
  );
}

OwnerComponent.defaultProps = {
  formData: {},
};

OwnerComponent.propTypes = {
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.instanceOf(Array).isRequired,
  getLandOwnerList: PropTypes.instanceOf(Function).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  formData: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  ownerList: _.get(api, `${c.GET_LAND_OWNER}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(OwnerComponent);
